<template>
  <div>
    <input
      ref="input"
      type="text"
      class="input input--border input--radius"
      :id="id"
      :placeholder="placeholder"
      @blur="handleInputBlurred()"
      @input="handleInputChanged()"
    >

    <p
      class="input--errors input--error"
      v-if="v?.$error"
    >
      {{ t('errors.input_text_required') }}
    </p>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useI18n } from '@/vendors/i18n'
import { useGoogleMaps } from '@/vendors/integrations'
import Address from '@/classes/addresses/Address'
import { get as _get } from 'lodash'

const address = defineModel({ type: Object, default: new Address() })

const { type, v } = defineProps({
  id: { type: String, required: true },
  placeholder: { type: String, default: '...' },
  type: { type: String, default: '' },
  v: { type: Object }
})

const { t } = useI18n()
const { loadGoogleMaps } = useGoogleMaps()

const mapping_address_components = {
  street_number: { key: 'number', type: 'short_name' },
  route: { key: 'line1', type: 'long_name' },
  locality: { key: 'city', type: 'long_name' },
  administrative_area_level_1: { key: 'state', type: 'short_name' },
  country: { key: 'country', type: 'short_name' },
  postal_code: { key: 'postal_code', type: 'shor<t_name' }
}

const options = {
  fields: ['address_components', 'geometry'],
  types: type ? [type] : []
}

const input = ref()
const autocomplete = ref()

const handleInputChanged = () => {
  if (!input.value.value) address.value = new Address()
}

const handleInputBlurred = () => v?.$touch()

const handlePlaceChanged = () => {
  const place = autocomplete.value.getPlace()

  if (!place) return address.value = new Address()

  const location = new Address({
    latitude: place?.geometry?.location?.lat(),
    longitude: place?.geometry?.location?.lng()
  })

  address.value = place.address_components?.reduce((address, component) => {
    const mapping_key = _get(component, 'types.0')
    const { key, type } = _get(mapping_address_components, mapping_key, {})

    if (key) address[key] = component[type]

    return address
  }, location)
}

onMounted(async () => {
  input.value.value = address.value.to_string

  await loadGoogleMaps()

  autocomplete.value = new google.maps.places.Autocomplete(input.value, options)
  autocomplete.value.addListener('place_changed', handlePlaceChanged)
})
</script>
